import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Button } from '@blueprintjs/core';
import CalendarInputWithButtonYYYYMMDD from '../blueprintWrappers/CalendarInputWithButtonYYYYMMDD';

class LeadDates extends Component {

	render() {
		return (
			<div>
				{this.showLastContactDate()}
				{this.showDueDate()}
				{this.showEnteredDate()}
			</div>
		);
	}

	showLastContactDate = () => {
		const { lastContactDate, onChange } = this.props;
		return (
			<div>
				{lastContactDate !== null ?
					<div>  Last Contact Date: 
						<CalendarInputWithButtonYYYYMMDD
							value={lastContactDate.substring(0, 10)}
							onChange={(returnObj) => onChange(returnObj, 'lastContactDate')}
							returnObj={{ attr: 'lastContactDate' }}
						/>
					</div>
					:
					<div>
						Last Contact Date 
					<Button /* TODO styling or toggle effect */
							onClick={(returnObj) => onChange(this.getToday(), 'lastContactDate')}
							label="Set as Today"
						> Set as Today
					</Button>
					</div>
				}
			</div>
		);
	}

	showDueDate = () => {
		const { dueDate, onChange } = this.props;
		return (
			<div>
				{dueDate !== null ?
					<div> Due Date: 
						<CalendarInputWithButtonYYYYMMDD
							value={dueDate.substring(0, 10)}
							onChange={(returnObj) => onChange(returnObj, 'dueDate')}
							returnObj={{ attr: 'dueDate' }}
						/>
					</div>
					:
					<div>
						Due Date 
						<Button /* TODO styling or toggle effect */
							onClick={(returnObj) => onChange(this.getToday(), 'dueDate')}
							label="Set as Today"
						> Set as Today
				</Button>
					</div>
				}
			</div>
		);
	}

	showEnteredDate = () => {
		const { enteredDate, onChange } = this.props;
		return (
			<div>

				{enteredDate !== null ?
					<div> Entered Date: 
						<CalendarInputWithButtonYYYYMMDD
							value={enteredDate.substring(0, 10)}
							onChange={(returnObj) => onChange(returnObj, 'enteredDate')}
							returnObj={{ attr: 'enteredDate' }}
						/>
					</div>
					:
					<div> Entered Date 
						<Button /* TODO styling or toggle effect */
							onClick={(returnObj) => onChange(this.getToday(), 'enteredDate')}
							label="Set as Today"
						> Set as Today
					</Button>
					</div>
				}
			</div>
		);
	}


	getToday = () => {
		return moment().format('YYYY-MM-DD');
	}
}
export default LeadDates;


// WEBPACK FOOTER //
// ./src/components/leadtracker/LeadDates.js